import env from '../../app/utils/env';

export type ENV = 'development' | 'staging' | 'production';

const PRODUCTION_HOST_URL = 'https://widget.rentgrata.com';

export const hostUrl = process.env.WIDGET_HOST_URL || PRODUCTION_HOST_URL;

export const libHost = process.env.LIB_HOST_URL || hostUrl;

export const zoidCDNUrl =
  'https://cdnjs.cloudflare.com/ajax/libs/zoid/6.0.80/zoid.min.js';
export const optimizeUrl = `https://www.googleoptimize.com/optimize.js?id=${process.env.OPTIMIZE_ID}`;
export const baseAPIUrl = process.env.BASE_API_URL || 'http://localhost:3000';

export const messengerUrl = `${hostUrl}/messenger.html`;
export const compactUrl = `${hostUrl}/compact.html`;
export const compactV2Url = `${hostUrl}/compact-v2.html`;
export const messengerV2Url = `${hostUrl}/messenger-v2.html`;
export const widgetScriptUrl = `${libHost}/rentgrata.js`;

// Zoid requires url[defaultEnv]. The iframe URL comes from WIDGET_HOST_URL at
// build time, so named environments such as qa2 share that same URL.
export function zoidUrl(url: string): { [key: string]: string } {
  return {
    development: url,
    staging: url,
    production: url,
    [env.environment]: url,
  };
}
